export default __webpack_public_path__ + "static/media/category_06.dcf64f89.png";